/**
 * Main
 * --------------------------------------------
 *
 * Carga de componente principal, objetos y librerías varías.
 *
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/tailwind.css";
import * as VueSpinnersCss from "vue-spinners-css";
import ToggleButton from "vue-js-toggle-button";
import i18n from "./i18n";
import VModal from "vue-js-modal";
import axios from "axios";
import VueAxios from "vue-axios";
import { Icon } from "leaflet";
import VTooltip from "v-tooltip";
import VueGauge from "vue-gauge";
import VueMobileDetection from "vue-mobile-detection";

/**
 *
 * Borrado y añadido de icono de favicon
 *
 */
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.use(VueSpinnersCss);
Vue.use(VModal, { dialog: true });
Vue.use(ToggleButton);
Vue.use(VTooltip);
Vue.use(VueMobileDetection);

Vue.component("vue-gauge", VueGauge);

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
